/* eslint-disable react/jsx-no-literals */
/* eslint-disable no-tabs */
import { FC } from 'react';

import { MpParagraph } from 'shared/ui/MpParagraph';
import { CodeStyled, ImageStyled, OlStyled, UlStyled } from './PrinterInstructions.styles';

export type ApplicationInstructionProps = {
	applicationId: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrinterInstructions: FC<ApplicationInstructionProps> = () => (
	<>
		<MpParagraph>
			Для подключения нужен Android-планшет, принтер и наклейки. Один планшет используется для печати маркировок,
			второй планшет — для упаковки.
		</MpParagraph>
		<OlStyled>
			<li>
				<a
					href='https://dodopizza.info/articles/84c70564-3282-40f3-a417-684b78090351'
					target='_blank'
					rel='noreferrer'
				>
					Закажите принтер и наклейки.
				</a>
			</li>
			<li>
				{`Установите на планшет Android приложение Принтер Додо. Приложение доступно в `}
				<a
					href='https://play.google.com/store/apps/details?id=com.dodopizza.foregroundprinter&hl=ru&gl=US'
					target='_blank'
					rel='noreferrer'
				>
					Google Play
				</a>
				{` и в `}
				<a href='https://appgallery.huawei.ru/app/C106634769' target='_blank' rel='noreferrer'>
					Huawei AppGallery
				</a>
			</li>
			<li>
				Подключите приложение к термопринтеру
				<UlStyled>
					<li>Включите Bluetooth на устройстве;</li>
					<li>Подключите устройство к принтеру через настройки Bluetooth в Android;</li>
					<li>
						{`Откройте приложение и нажмите кнопку `}
						<CodeStyled>Connect</CodeStyled>
						{` для подключения приложения к термопринтеру;`}
					</li>
					<li>
						{`Удостоверьтесь, что статус сменился с `}
						<CodeStyled>Printer not connected</CodeStyled>
						{` на `}
						<CodeStyled>Printer connected</CodeStyled>
						{` - это значит, что приложение успешно подключилось к термопринтеру;`}
						<ImageStyled src='https://cdn.dodostatic.net/static/marketplace/printer/instructions1-new' />
					</li>
				</UlStyled>
			</li>
			<li>
				Привяжите устройство в Dodo IS
				<UlStyled>
					<li>
						{`Нажмите на кнопку `}
						<CodeStyled>Device registration</CodeStyled>, на экране отобразится четырехзначный пин-код;
						<ImageStyled src='https://cdn.dodostatic.net/static/marketplace/printer/instructions2-new' />
					</li>
					<li>
						<strong>На компьютере</strong>
						{` откройте интерфейс Менеджера смены. В меню выберите `}
						<CodeStyled>Устройства</CodeStyled>
						{`. Во вкладке `}
						<CodeStyled>Устройства</CodeStyled>
						{` появится вкладка `}
						<CodeStyled>Устройства 2.0</CodeStyled>, откройте её;
					</li>
					<li>
						{`Нажмите на кнопку `}
						<CodeStyled>Добавить</CodeStyled>
						{`, введите код, название устройства, выберите функцию `}
						<CodeStyled>Принтер этикеток</CodeStyled>
						{` и нажмите кнопку  `}
						<CodeStyled>Сохранить</CodeStyled>;
						<ImageStyled src='https://cdn.dodostatic.net/static/marketplace/printer/instructions3-new' />
					</li>
					<li>
						В приложении отобразится окно выбора типа устройства. Нажмите на необходимый тип — принтер
						упаковки или принтер маркировки сроков годности.
						<ImageStyled src='https://cdn.dodostatic.net/static/marketplace/printer/instructions4-new' />
					</li>
				</UlStyled>
				<li>Приложение готово к работе.</li>
			</li>
		</OlStyled>
	</>
);
